import { Component, OnInit, Optional } from "@angular/core";
import esri = __esri;

import { BaseMapControlComponent } from "../base-map-control/base-map-control.component";
import { GeometryFactory } from "../../../builder/components/state/controls/config/data/well-related/gis-map/geometry-manager/factories/geometry.factory";
import { GeometryLayer } from "../../../builder/components/state/controls/config/data/well-related/gis-map/geometry-manager/models/geometry-layer.model";
import { deepClone } from "../../../builder/models/editor.model";

import { RuleCompiler } from "../../../flow/services/rule-compiler.service";
import { FlowButtonOverrideService } from "../../../flow/services/flow-button-override.service";
import { Renderer } from "../../../gis/components/odnr-map/renderer/renderer.interface";
import { DocumentManagementService } from "../../../common/services/document-management.service";
import { ContextInteractionService } from "../../services/context-interaction.service";


@Component({
    selector: "map-control",
    templateUrl: "./map-control.component.html",
    standalone: false
})

export class MapControlComponent extends BaseMapControlComponent implements OnInit {
    static componentName = "MapControlComponent";

    filteredConfig: any;

    constructor(public readonly compiler: RuleCompiler,
        @Optional() public readonly buttonOverride: FlowButtonOverrideService,
        @Optional() protected readonly _docService: DocumentManagementService,
        public readonly contextService: ContextInteractionService) {
        super(buttonOverride, _docService, contextService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.ensureConfig();

        this.filteredConfig = deepClone(this.componentData.config);
        this.convertData();
    }

    private ensureConfig(): void {
        if (!this.componentData.contextTarget) {
            console.warn("ensuring default context target of $.data.mapControl");
            this.componentData.contextTarget = "$.data.mapControl"; //must have a place to store a reference to the map image for eDiscovery
        }
        if (!this.componentData.config.contextLocations) {
            console.warn("reconstituting contextLocation config for map control");
            this.componentData.config.contextLocations = {
                latitude: "$.data.mapLatitude.value",
                longitude: "$.data.mapLongitude.value"
            };
        }

        if (!this.componentData.config.contextLocations.latitude) {
            console.warn("reconstituting contextLocation latitude config for map control");
            this.componentData.config.contextLocations.latitude = "$.data.mapLatitude.value";
        }

        if (!this.componentData.config.contextLocations.longitude) {
            console.warn("reconstituting contextLocation longitude config for map control");
            this.componentData.config.contextLocations.longitude = "$.data.mapLongitude.value";
        }
    }

    private convertData() {
        let contextLocations = this.componentData.config.contextLocations;
        try {
            this.storedLatitude = Number(this.getContext("latitude"));
            this.storedLongitude = Number(this.getContext("longitude"));
            this.currentLatitude = Number(this.getContextData(contextLocations.latitude));
            this.currentLongitude = Number(this.getContextData(contextLocations.longitude));
            this.storeContext(this.currentLatitude, "latitude");
            this.storeContext(this.currentLongitude, "longitude");
            this.filteredConfig.properties.center = [this.currentLongitude, this.currentLatitude];
            if (this.filteredConfig.geometry.layers) {
                let geometry = [];
                for (let g = 0; g < this.filteredConfig.geometry.layers.length; g++) {
                    let layer: GeometryLayer;
                    if (this.filteredConfig.geometry.layers[g].isConditional) {
                        const rule = this.filteredConfig.geometry.layers[g].rule;
                        const fn = this.compiler.compileBooleanRule(rule, this.componentContext);
                        const result = fn();
                        if (result) layer = this.filteredConfig.geometry.layers[g];
                    } else {
                        layer = this.filteredConfig.geometry.layers[g];
                    }
                    if (layer !== undefined) {
                        for (var config of layer.geometry) {
                            let geom = GeometryFactory.CreateGeometry(config, this.componentContext);
                            let idx = layer.geometry.findIndex(x => x === config);
                            layer.geometry[idx] = { ...config, ...(Object.assign({}, geom)) };
                        }
                        geometry.push(layer);
                    }
                }
                this.filteredConfig.geometry.layers = geometry;
            }

        } catch (ex) { console.error(ex); }
    }

    onMapReady(data: Renderer<esri.SceneView | esri.MapView>): void {
        super.onMapReady(data);
    }
}